<template>
  <div style="padding: 0 0 30px">
    <a-row>
      <a-col :span="24" style="padding: 20px; background-color: #fff; border-radius: 0 0 10px 10px">
        <a-row :gutter="[15, 15]" class="row-box" style="padding-top: 10px">
          <a-col :lg="7" :md="9" :sm="24" :xl="4">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :isShowEmpty="false"
              @select="
                (record) => {
                  $set(queryParam, 'classId', undefined)
                  $set(selectLevelObj, 'grade', record)
                }
              "
              @clear="$set(queryParam, 'classId', undefined)"
            />
          </a-col>
          <a-col :lg="7" :md="9" :sm="24" :xl="4">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="
                'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
              "
              :disabled="!queryParam.gradeId"
              :isShowEmpty="false"
              @select="
                (record) => {
                  $set(selectLevelObj, 'class', record)
                }
              "
            />
          </a-col>
          <a-col :lg="6" :md="9" :sm="24" :xl="4">
            <a-range-picker :value="rangeDate" style="width: 100%" @change="onRangeChange" />
          </a-col>

          <a-col v-for="(item, index) in searchItem" :key="index" :span="2" class="tag-col">
            <div :style="{ borderLeft: `4px solid ${searchItemColor[index]}` }" class="tag-item">
              <span class="tag-name">{{ item }}</span>
              <a-icon class="delete-icon" type="close-circle" @click="deleteBtn(item, index)" />
            </div>
          </a-col>

          <a-col v-if="contrastInputStatus" :span="4" class="select-box">
            <a-select
              :not-found-content="null"
              show-search
              @search="handleSearch"
              @inputKeydown.enter="
                () => {
                  contrastInputStatus = false
                }
              "
            >
              <div slot="dropdownRender">
                <recycle-scroller
                  :buffer="1000"
                  :item-size="40"
                  :items="keyword"
                  :prerender="200"
                  class="virtual-list"
                  key-field="period_id"
                  style="max-height: 200px"
                >
                  <template v-slot="{ item, index }">
                    <div :key="index" class="list-item" @click="handleSelect(item.period_id, item)">
                      {{ item.name }}
                    </div>
                  </template>
                </recycle-scroller>
              </div>
            </a-select>
            <a-icon
              class="select-del-icon"
              type="close-circle"
              @click="
                () => {
                  contrastInputStatus = false
                }
              "
            />
          </a-col>
          <a-col :span="3">
            <div style="display: flex">
              <a-button style="margin-right: 10px" @click="addContrast">+ 添加对比</a-button>
              <a-button icon="search" type="primary" @click="chaDate">查询</a-button>
            </div>
          </a-col>
        </a-row>
        <a-col :span="16" style="padding-right: 8px">
          <a-card :bordered="false" :loading="loading" class="left-card-box">
            <LineChart
              ref="schoolMoodRef"
              :dataSource="schoolMood"
              :fields="moodField"
              :title="`${lineMoodTitle}【情绪变化趋势】`"
              height="280px"
              showAvgBtn
            >
              <template slot="titleExtra">
                <a-button class="add-btn" type="primary" @click="addEventClick">添加事件</a-button>
              </template>
            </LineChart>
          </a-card>
        </a-col>
        <a-col :span="8" style="padding-left: 8px">
          <a-tabs @change="changeTab" class="emotional-trend-card">
            <a-tab-pane v-for="item in emotionalTrendTabs" :key="item.key" :tab="item.tab">
              <a-card :bordered="false" :loading="loading">
                <TableList
                  :columns="emotionalTrend.columns"
                  :scroll="{ y: 220 }"
                  :tableData="emotionalTrend.tableData"
                  style="height: 294px"
                  @addContrast="(record) => addContrastCell(record)"
                >
                  <div slot="total" slot-scope="{ record }" style="text-align: left">
                    <div style="font-size: 16px; font-weight: bold">
                      {{ record.total }}
                    </div>
                    <div>
                      <img
                        v-if="record.total != record.school"
                        :src="
                          require(`@assets/imgs/school/${
                            record.total > record.school ? 'rise' : 'descend'
                          }.png`)
                        "
                        style="width: 10px; margin-right: 5px"
                        alt=""
                      />
                      <span style="font-size: 13px">全校平均值{{ record.school }}</span>
                    </div>
                  </div>
                </TableList>
              </a-card>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-col>
    </a-row>
    <!--班主任使用概览-->
    <a-row>
      <a-col :span="24" class="title-1" style="margin: 20px 0 10px">班主任使用概览</a-col>
      <a-col :span="24">
        <a-col :span="12" style="padding-right: 8px">
          <a-card :bordered="false" :loading="loading" class="left-card-box">
            <LineChart
              ref="teacherVisitChartRef"
              :dataSource="teacherVisitChart.dataSource"
              :fields="teacherVisitChart.fields"
              height="260px"
              style="margin-bottom: 20px"
              title="教师访问量趋势"
            />
          </a-card>
        </a-col>
        <a-col :span="12" style="padding-left: 8px">
          <a-card :bordered="false" :loading="loading" class="right-card-box" style="padding: 0">
            <TableList
              :columns="teacherUseList.columns"
              :loading="teaLoading"
              :pagination="pagination"
              :scroll="{ y: 190 }"
              :sortKeys="{ keys: ['ranking'] }"
              :tableData="teacherUseList.tableData"
              size="small"
              style="height: 310px"
              @change="handleTableChange"
            >
              <div slot="titleRightExtra" class="title-right-extra flex-between">
                <div>
                  <span>
                    {{ teacherUseList.title }}
                  </span>
                  <span v-for="(item, index) in teaVisitList" :key="index" class="tea-text">
                    {{ item.title }}
                    <span class="tea-text-num">{{ item.value }}</span>
                  </span>
                </div>
                <div>
                  <a-popconfirm
                    title="确定要一键提醒吗？"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="teacherUseOneRemind()"
                  >
                    <a-button type="primary" :loading="remindLoading" ghost>一键提醒</a-button>
                  </a-popconfirm>
                </div>
              </div>
              <div slot="teacherlRemind" slot-scope="slotProps">
                <a-popconfirm
                  title="确定要提醒吗？"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="teacherRemindList(slotProps)"
                >
                  <span style="color: #1890ff; cursor: pointer">提醒</span>
                </a-popconfirm>
              </div>
            </TableList>
          </a-card>
        </a-col>
      </a-col>
      <a-col :span="24" class="title-1" style="margin: 20px 0 10px">学生/家长活跃情况</a-col>
      <a-col :span="24">
        <a-card :bordered="false" :loading="loading" class="left-card-box">
          <a-row>
            <a-col :span="12">
              <LineChart
                ref="studentActivityRef"
                :dataSource="studentActivity"
                :fields="['学生活跃度']"
                :grid="grid"
                height="250px"
                style="margin-bottom: 10px"
                title="学生活跃度对比"
              />
            </a-col>
            <a-col :span="12">
              <LineChart
                ref="parentVisitRef"
                :dataSource="parentVisit"
                :fields="['家长活跃度']"
                :grid="grid"
                height="250px"
                style="margin-bottom: 10px"
                title="家长关注度对比"
              />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <!--情绪记录-->
    <MoodRecordCom />
    <!--教师关怀模态框-->
    <TeacherCareModal ref="teacherCareModal" />
    <!--添加事件模态框-->
    <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
  </div>
</template>

<script>
import CountAnimation from '@comp/CountAnimation/index.vue'
import { getAction } from '@api/manage'
import LineChart from '@comp/echartZyz/components/LineChart.vue'
import TableList from '@comp/chart/TableList.vue'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css' // 引入它的 css
import moment from 'moment'
import AddEventModal from '@/comUi/AddEventModal.vue'
import MoodRecordCom from '@/comUi/MoodRecordCom'
import {
  addLineCompare,
  deleteLineCompare,
  handleLineChartData,
  randomColor,
  saveFieldsArrKey,
  simpleDebounce,
} from '@/utils/util'
import TeacherCareModal from '@/comUi/TeacherCareModal.vue'

export default {
  name: 'PsyEmotionOverview',
  components: {
    TeacherCareModal,
    CountAnimation,
    // CreatePlan,
    RecycleScroller,
    LineChart,
    TableList,
    AddEventModal,
    MoodRecordCom,
  },
  props: {
    modeType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryParam: {},
      selectLevelObj: {
        grade: {},
        class: {},
      },
      rangeDate: [],
      searchItem: [],
      searchItemColor: [],
      schoolMood: [],
      moodField: ['愉悦指数', '关爱名单愉悦指数'],
      contrastInputStatus: false,
      keyword: [],
      searchContextList: [],
      lineMoodTitle: '',
      emotionalTrendTabs: [
        {
          tab: '年级情绪指数',
          key: '0',
        },
        {
          tab: '班级情绪指数',
          key: '1',
        },
      ],
      emotionalTrend: {
        url: '/statistic/gradeTrendsRanking',
        columns: [
          {
            title: '序号',
            dataIndex: 'ranking',
            align: 'center',
            width: 60,
            customRender: (_, record, index) => index + 1,
          },
          {
            title: '年级',
            dataIndex: 'name',
            align: 'center',
          },
          {
            title: '情绪指数',
            dataIndex: 'total',
            align: 'center',
            sorter: (a, b) => {
              return a.total - b.total
            },
            scopedSlots: { customRender: 'total' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 100,
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
      },
      grid: { top: '10%', bottom: '25%', left: '12%', right: '12%' },
      teacherVisitChart: {
        fields: ['教师访问次数'],
        dataSource: [],
      },
      remindLoading: false,
      teacherUseList: {
        title: '教师使用情况',
        columns: [
          {
            title: '排名',
            dataIndex: 'index',
            align: 'center',
            width: 60,
            customRender: (_, record, index) => index + 1,
          },
          {
            title: '班级',
            dataIndex: 'className',
            align: 'center',
          },
          {
            title: '教师姓名',
            dataIndex: 'teacherName',
            align: 'center',
            customRender: (_, record) => {
              return (
                <div
                  style="color: #189EFF;cursor: pointer;"
                  onClick={() => this.viewTeacherCare(record)}
                >
                  {record.teacherName}
                </div>
              )
            },
          },
          {
            title: '访问次数',
            dataIndex: 'visitCnt',
            align: 'center',
            sorter: (a, b) => a.visitCnt - b.visitCnt,
          },
          {
            title: '未处理提醒',
            dataIndex: 'unDealWarnCnt',
            align: 'center',
            sorter: (a, b) => a.unDealWarnCnt - b.unDealWarnCnt,
          },
          {
            title: '操作',
            dataIndex: 'teacherlRemind',
            align: 'center',
            scopedSlots: { customRender: 'teacherlRemind' },
          },
        ],
        tableData: [],
      },
      studentActivity: [],
      parentVisit: [],
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showSizeChanger: true,
        total: 0,
      },
      teaVisitList: [],
      teaLoading: false,
      compareData: [],
      loading: false,
      stuCardList: [
        {
          title: '重点关爱学生',
          list: [
            {
              value: 0,
              key: 'zgaCnt',
              label: '重点关爱学生数',
              backgroundColor: '#F66860',
              value2: 0,
              key2: 'zgaCnt2',
              label2: '已关爱学生次数',
            },
            {
              value: 0,
              key: 'pgCnt',
              label: '待评估学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
          ],
        },
        {
          title: '小叮当提醒学生',
          list: [
            {
              value: 100,
              label: '提醒学生',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              label: '已查看学生数',
            },
            {
              value: 0,
              label: '已归档学生数',
            },
          ],
        },
      ],
      pieChartList: [
        {
          title: '心理辅导管理',
          chartData: [
            { value: 0, name: '未确认预约' },
            { value: 0, name: '未辅导' },
            { value: 0, name: '已辅导' },
          ],
          pieText: [],
          subTitle: '心理辅导预约处理率',
          legendArr: [
            { value: 0, name: '班主任预约' },
            { value: 0, name: '家长预约' },
            { value: 0, name: '危机上报' },
          ],
          rate: 98,
        },
        {
          title: '我的计划',
          chartData: [
            { value: 2, name: '心理测评计划' },
            { value: 136, name: '校园活动计划' },
            { value: 13, name: '待心理评估学生' },
          ],
        },
      ],
    }
  },
  mounted() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.getTrendsRanking()
    this.chaDate()
  },
  methods: {
    // 查询事件
    async chaDate() {
      this.contrastInputStatus = false
      this.searchItem = []
      this.context2 = ''
      await this.loadData()
      this.setLineMoodTitle()
      this.getSearchKeyword()
    },
    loadData() {
      this.getSchoolChangeTrend()
      this.getStuPraCompare()
      this.getTeacherSituation()
      this.getTeacherVisitTrend()
      this.getTrendsRanking()
    },
    // 获取校园变化趋势折线图数据
    getSchoolChangeTrend() {
      // this.$refs.schoolMoodRef.showLoading()
      getAction('/statistic/schoolMoodTrend', this.queryParam)
        .then((res) => {
          if (res.success) {
            const { filedList, lineData } = handleLineChartData(res.result)
            console.log('schoolMoodTrend折线图--', filedList, lineData)
            this.schoolMood = lineData
            this.moodField = filedList
          }
        })
        .finally(() => {
          // this.$refs.schoolMoodRef.hideLoading()
        })
    },
    // 设置心情变化趋势标题
    setLineMoodTitle() {
      this.lineMoodTitle = this.queryParam.classId
        ? this.selectLevelObj.class.text
        : this.queryParam.gradeId
        ? this.selectLevelObj.grade.text
        : '校园'
    }, // 添加对比
    addCompareData(params) {
      // console.log('添加对比参数', {...this.queryParam, ...params});
      getAction('/statistic/compareData', { ...this.queryParam, ...params })
        .then((res) => {
          if (res.success) {
            this.compareData = res.result
            // this.schoolMood.push(this.compareData)
            const { lineData, filedList } = addLineCompare(
              this.schoolMood,
              this.moodField,
              this.compareData
            )
            this.schoolMood = lineData
            this.moodField = filedList
          }
        })
        .finally(() => {})
    },
    changeTab(key) {
      const keyObj = {
        0: {
          title: '年级',
          url: '/statistic/gradeTrendsRanking',
        },
        1: {
          title: '班级',
          url: '/statistic/classTrendsRanking',
        },
      }
      this.emotionalTrend.url = keyObj[key].url
      this.$set(this.emotionalTrend.columns[1], 'title', keyObj[key].title)
      this.getTrendsRanking()
    },
    // 年级、班级情绪趋势排名
    getTrendsRanking() {
      getAction(this.emotionalTrend.url, {
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }).then((res) => {
        if (res.success) {
          const schoolData = res.result.map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
            }
          })
          this.$set(this.emotionalTrend, 'tableData', schoolData)
        }
      })
    },
    getSearchKeyword() {
      getAction('/statistic/getKeyword', this.queryParam).then((res) => {
        if (res.success) {
          this.searchContextList = res.result
          this.keyword = res.result
        }
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeType = 'range'
      this.rangeDate = dates
      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
      this.moodField = ['愉悦指数', '关爱名单愉悦指数']
      this.searchItem = []
    },
    handleSearch: simpleDebounce(function (value) {
      this.queryParam.con = value || ''
      if (!this.searchContextList.length) {
        this.getSearchKeyword()
      } else {
        this.keyword = value
          ? this.searchContextList.filter((item) => item.name.includes(value))
          : this.searchContextList
      }
    }, 300),
    handleSelect(value, item) {
      console.log('item---', item)
      let currItem = this.keyword.find((i) => i.period_id == value)
      this.$set(this.queryParam, 'crux', currItem.name)
      this.$set(this.queryParam, 'id', value)
      if (value) {
        if (!this.searchItem.includes(this.queryParam.crux)) {
          this.searchItem.push(this.queryParam.crux)
          this.searchItemColor.push(randomColor())
        }
        this.context2 = ''
        this.addCompareData({ dataType: currItem.dataType, tenantId: currItem.tenantId })
      }
      this.contrastInputStatus = false
      this.keyword = this.searchContextList
    },
    deleteBtn(item) {
      console.log('删除对比项：', item)
      console.log('this.schoolMood--', this.schoolMood)
      const lineData = deleteLineCompare(this.schoolMood, item)
      const idx_s = this.searchItem.indexOf(item)
      this.searchItem.splice(idx_s, 1)
      this.searchItemColor.splice(idx_s, 1)
      const idx = this.moodField.indexOf(item)
      if (idx == -1) return
      this.moodField.splice(idx, 1)
      this.schoolMood = lineData
    },
    addContrast() {
      this.contrastInputStatus = true
    },
    addContrastCell(record) {
      console.log('添加对比', record)
      this.$set(this.queryParam, 'id', record.class_id || record.grade_id)
      this.$set(this.queryParam, 'crux', record.name)
      if (!this.searchItem.includes(this.queryParam.crux)) {
        this.searchItem.push(this.queryParam.crux)
        this.searchItemColor.push(randomColor())
      }
      // this.chaDate()
      this.addCompareData({
        tenantId: record.tenantId,
      })
    },
    // 添加事件
    addEventClick() {
      this.$refs.addEventModal.show(this.schoolMood, this.moodField)
    },
    // 刷新标注
    refreshMarked(record) {
      const porintIndex = this.schoolMood.findIndex(
        (item) => item[record.filed + 'id'] == record.id && item.type == record.type
      )
      if (porintIndex != -1) {
        const incident = record.filed + 'incident'
        this.$set(this.schoolMood[porintIndex], incident, record['incident'])
        this.schoolMood = [...this.schoolMood]
        // console.log('刷新标注的索引：', porintIndex);
        // console.log('刷新标注后的数据：', this.schoolMood);
      }
    },
    // 教师列表分页变化
    handleTableChange(page, _, sorter) {
      this.pagination = page
      // this.getTeacherSituation(sorter)
    },
    // 教师访问量趋势
    async getTeacherVisitTrend() {
      this.$refs.teacherVisitChartRef.showLoading()
      const res = await getAction('/statistic/teacherVisit', this.queryParam)
      if (res.success) {
        this.$set(this.teacherVisitChart, 'dataSource', res.result.resultList)
        console.log('教师访问量趋势：', this.teacherVisitChart)
      }
      this.$refs.teacherVisitChartRef.hideLoading()
    },
    // 学生/家长活跃情况
    getStuPraCompare() {
      let query = {
        tenantId: this.queryParam.tenantId,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }
      //学生活跃情况
      getAction('/statistic/studentActivityTrend', query)
        .then((res) => {
          this.$refs.studentActivityRef.showLoading()
          // console.log('学生活跃情况：', res.result)
          if (res.success) {
            this.studentActivity = res.result?.map?.((item) => ({
              type: item.type,
              学生活跃度: item.activity,
            }))
          }
        })
        .finally(() => {
          this.$refs.studentActivityRef.hideLoading()
        })
      //家长访问情况
      getAction('/statistic/parentVisitTrend', query)
        .then((res) => {
          this.$refs.parentVisitRef.showLoading()
          if (res.success) {
            this.parentVisit = res.result?.map?.((item) => ({
              type: item.type,
              家长活跃度: item.visit,
            }))
          }
        })
        .finally(() => {
          this.$refs.parentVisitRef.hideLoading()
        })
    },
    // 教师使用情况一键提醒
    async teacherUseOneRemind() {
      this.remindLoading = true
      const res = await getAction('/statistic/teacherSituation', {
        ...this.queryParam,
        type: 1,
      })
      this.remindLoading = false
      const { success, result } = res
      if (success) {
        this.$message.success(result || '一键提醒成功')
      } else {
        this.$message.error(result || '一键提醒失败')
      }
    },
    // 教师使用情况列表
    getTeacherSituation() {
      this.teaLoading = true
      getAction('/statistic/teacherSituation', this.queryParam)
        .then((res) => {
          console.log(res)
          if (res.success) {
            const classData = res.result.map((item, index) => {
              return {
                ...item,
                index: index + 1,
              }
            })
            this.$set(this.teacherUseList, 'tableData', classData)
          }
        })
        .finally(() => {
          this.teaLoading = false
        })
    },
    // 查看教师关怀
    viewTeacherCare(data) {
      data.name = data.teacherName
      data.id = data.teacherId
      this.$refs.teacherCareModal.show(data)
    },
    teacherRemindList(slotProps) {
      const id = slotProps.record.id
      const customText =
        slotProps.record.teacherName +
        '老师您好，您收到一条来自后台' +
        '的提醒消息，本周您还有' +
        slotProps.record.unDealWarnCnt +
        '条提醒未处理，请及时跟进处理。'

      const requestData = {
        teacherId: id,
        text: customText,
      }
      //催办班主任提醒处理
      getAction('/aigoes/schoolClass/earlyWarning', requestData).then((res) => {
        console.log(res)
        if (res.success) {
          // this.$message.success('催办成功！');
          this.$notification['success']({
            message: '通知',
            description: '已提醒班主任！',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.tag-col {
  animation: tagAppear 0.3s linear;
}

.select-box {
  position: relative;
  animation: tagAppear 0.3s linear;
}

::v-deep {
  .ant-select {
    width: 100% !important;
  }
}

@keyframes tagAppear {
  from {
    transform: translate(20px, -20px) scale(0.4);
    opacity: 0;
  }
  to {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
}

.tag-item {
  width: 100% !important;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding-left: 5px;
  /* 不换行 */

  .tag-name {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.delete-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -6px;
}

.select-del-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -1px;
  right: 3px;
}

.line-title {
  font-size: 17px;
  font-weight: 600;
  color: #262626;
  font-family: 'Arial', sans-serif;
}

.virtual-list {
  /* y轴滚动 */
  overflow-y: auto;
  /* 隐藏x轴滚动条 */
  overflow-x: hidden;

  .list-item {
    display: flex;
    align-items: center;
    padding-left: 10px;
    min-height: 40px;
    font-size: 14px;
    cursor: pointer;
  }

  .list-item:hover {
    background-color: #e6f7ff;
  }
}

.left-card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  // margin: 10px;
  ::v-deep {
    .ant-card-body {
      padding-bottom: 16px;
    }
  }
}

.right-card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  /deep/ .ant-pagination {
    margin-bottom: 0 !important;
  }
  ::v-deep {
    .ant-card-body {
      padding-bottom: 16px;
    }
  }
}

.emotional-trend-card {
  padding: 0 10px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  ::v-deep {
    .ant-tabs-bar {
      margin-bottom: 10px !important;
    }
  }
  ::v-deep {
    .ant-card-body {
      padding: 0 16px;
    }
  }
}

.title-right-extra {
  width: 100%;
  font-size: 16px;
  color: #333333;
  font-weight: bold;

  .tea-text {
    margin-left: 15px;
    font-size: 15px;
    font-weight: 500;
    color: #404040;

    .tea-text-num {
      font-size: 16px;
      color: #3ba1f5;
    }
  }
}

.equipment-list {
  .equipment-item {
    box-sizing: border-box;
    width: 24%;
    height: 164px;
    padding: 20px;
    background-color: #fff;
    border-radius: 12px;
    .icon-area {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .num {
      font-size: 18px;
      color: #ff0000;
      font-weight: 500;
    }
  }
}
.row-box {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 20px 10px;
  margin-bottom: 10px;
  border-radius: 8px;
}
.pie-item {
  width: 50%;
  padding: 10px 12px;
  &:nth-child(odd) {
    padding-left: 0;
  }
  &:nth-child(even) {
    padding-right: 0;
  }
}
.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
